export default "__VITE_ASSET__MSSFyWmL__"